import { render } from "./verificarTelefono.vue?vue&type=template&id=d0244ad4"
import script from "./verificarTelefono.vue?vue&type=script&lang=js"
export * from "./verificarTelefono.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__